





























import {
  defineComponent, ref,
} from '@vue/composition-api';
import { Popup } from '@hb/coffee';
import store from '@/store';
import { local } from '@/shared/utils/storage';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';

export default defineComponent({
  components: {
    Popup,
  },
  props: {
    amount: {
      type: String,
      required: true,
    },
    showFullAmountCouponTag: {
      type: Boolean,
      required: true,
    },
    commodityId: {
      type: String,
      required: true,
    },
  },
  emits: ['confirm', 'cancel', 'close'],
  setup(props, context) {
    const show = ref(false);
    const getFullAmountPopKey = () => `FINANCE_LOAN_FULL_AMOUNT_POP_KEY_${store.state.base?.userId || ''}`;
    let resolvePromise: ((value: boolean) => void) | null = null;

    /** 打开弹窗逻辑
     * @returns 返回 Promise，resolve 为 true 时表示可以继续流程，resolve 为 false 时表示需要中断流程
     */
    const open = (): Promise<boolean> => new Promise((resolve) => {
      /** 如果 showFullAmountCouponTag 为 false || 命中疲劳度：每天一次，直接 resolve true */
      if (!props.showFullAmountCouponTag || local.get(getFullAmountPopKey())) {
        resolve(true);
        return;
      }

      ubtSetupModuleExpose('finance_loan_apply_moneyFullGuidPop', {
        commodityId: props.commodityId,
      });

      // 如果 showFullAmountCouponTag 为 true，打开弹窗
      show.value = true;
      /** 疲劳度：每天一次 */
      local.set(getFullAmountPopKey(), 1, 0, new Date().setHours(23, 59, 59, 999));
      resolvePromise = resolve;
    });

    const closePopup = (result: boolean, emitEvent?: string) => {
      // 通用关闭弹窗方法
      show.value = false;
      if (resolvePromise) {
        resolvePromise(result);
        resolvePromise = null;
      }
      if (emitEvent) {
        context.emit(emitEvent);
      }
    };

    /** 全额提现 */
    const handleConfirm = () => {
      ubtSetupPageButton('finance_loan_apply_moneyFullGuidPop_withdrawAll', {
        commodityId: props.commodityId,
      });
      // 点击满额提现时返回 false
      closePopup(false, 'confirm');
    };

    /** 狠心放弃 */
    const handleCancel = () => {
      ubtSetupPageButton('finance_loan_apply_moneyFullGuidPop_giveUp', {
        commodityId: props.commodityId,
      });
      // 点击狠心放弃时返回 true
      closePopup(true, 'cancel');
    };

    const close = () => {
      // 关闭弹窗并返回 false，不触发 emit
      closePopup(false);
    };

    return {
      show,
      open,
      close,
      handleConfirm,
      handleCancel,
    };
  },
});
